// extracted by mini-css-extract-plugin
export default {"button":"styles_button__lW-I3","editButton":"styles_editButton__uPMM3","deleteButton":"styles_deleteButton__wHfOI","link":"styles_link__oVPLK"};